// extracted by mini-css-extract-plugin
module.exports = {"root":"Pile__root","center":"Pile__center"};